module.exports = __webpack_public_path__ + "static/media/heartline_full.2b1af6d6.svg";